export const TwitchIcon = () => {
    return (
        <svg
            width="9"
            height="10"
            viewBox="0 0 9 10"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M1.71467 0L0 1.71467V7.88749H2.05761V9.60216L3.77228 7.88749H5.14402L8.23042 4.80108V0H1.71467ZM7.54456 4.45815L6.17282 5.82988H4.80108L3.60081 7.03015V5.82988H2.05761V0.685869H7.54456V4.45815Z"
                fill="currentColor"
            />
            <path d="M6.5157 1.88614H5.82983V3.94375H6.5157V1.88614Z" fill="currentColor" />
            <path d="M4.62972 1.88614H3.94385V3.94375H4.62972V1.88614Z" fill="currentColor" />
        </svg>
    );
};
